export const GET_ASSET_TYPES = 'estatePlan/GET_ASSET_TYPES';
export const GET_ASSET_TYPES_BY_CATEGORY =
  'estatePlan/GET_ASSET_TYPES_BY_CATEGORY';
export const ADD_ASSET_TYPE = 'estatePlan/ADD_ASSET_TYPE';
export const EDIT_ASSET_TYPE = 'estatePlan/EDIT_ASSET_TYPE';
export const DELETE_ASSET_TYPE = 'estatePlan/DELETE_ASSET_TYPE';
